import { useEffect, useState } from "react";
import { Lock, ShieldCheck, Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { addAllowlist, getAllowlist, removeAllowlist } from "@/lib/scoutApi";
import { extractApiError } from "@/lib/api";

export const AllowListPanel = () => {
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getAllowlist().then(setData).catch(() => {});
  }, []);

  const run = async (fn, ok) => {
    setBusy(true);
    try {
      setData(await fn());
      toast.success(ok);
      setEmail("");
    } catch (err) {
      toast.error(extractApiError(err, "Could not update the allow-list."));
    } finally {
      setBusy(false);
    }
  };

  if (!data) return null;

  return (
    <section data-testid="scout-allowlist" className="border border-slate-200 p-5">
      <div className="text-xs tracking-tight text-[var(--accent)] mb-1 flex items-center gap-2">
        <ShieldCheck className="w-3.5 h-3.5" /> Who can sign in with Google
      </div>
      <p className="text-xs text-slate-500 mb-4">These Google accounts open Scout without the passphrase. Removing one also ends their sessions.</p>
      <ul className="space-y-1.5">
        {data.locked.map((e) => (
          <li key={e} data-testid={`scout-allow-${e}`} className="flex items-center justify-between gap-3 text-sm text-[#0A192F]">
            <span className="truncate">{e}</span>
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-slate-400" title="Set in server config"><Lock className="w-3 h-3" /> locked</span>
          </li>
        ))}
        {data.extra.map((e) => (
          <li key={e} data-testid={`scout-allow-${e}`} className="flex items-center justify-between gap-3 text-sm text-[#0A192F]">
            <span className="truncate">{e}</span>
            <button type="button" data-testid={`scout-allow-remove-${e}`} disabled={busy} aria-label={`Remove ${e}`}
              onClick={() => run(() => removeAllowlist(e), `${e} removed`)}
              className="text-slate-400 hover:text-red-600 transition-colors">
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </li>
        ))}
      </ul>
      <form
        className="mt-4 flex gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          run(() => addAllowlist(email), `${email.trim().toLowerCase()} can now sign in`);
        }}
      >
        <input type="email" data-testid="scout-allow-input" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="name@gmail.com"
          className="flex-1 border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-[var(--accent)]" />
        <button type="submit" data-testid="scout-allow-add" disabled={busy || !email}
          className="inline-flex items-center gap-1.5 border border-[#0A192F] hover:bg-[#0A192F] hover:text-white disabled:opacity-40 px-3 py-2 text-xs font-medium transition-colors">
          <UserPlus className="w-3.5 h-3.5" /> Allow
        </button>
      </form>
    </section>
  );
};

export default AllowListPanel;
